// One writer per open session: coalesce edits behind the current request and only
// acknowledge successful writes. Failed payloads remain available for retry.
export function createCanvasSaver(save) {
  let pending, accepted, running, revision = 0
  const dirty = () => !!pending && pending.key !== accepted
  return {
    setRevision(value) { revision = value },
    update(payload, restored = false) {
      const key = JSON.stringify(payload)
      pending = { key, payload: JSON.parse(key) }
      if (restored) accepted = key
    },
    dirty,
    flush() {
      if (running) return running
      running = (async () => {
        while (dirty()) {
          const current = pending
          const result = await save(current.payload, revision)
          if (!Number.isInteger(result?.revision)) throw new Error('Save acknowledgement is missing its revision. Update the API and retry.')
          revision = result.revision
          accepted = current.key
        }
      })().finally(() => { running = null })
      return running
    },
  }
}
